import React, { useEffect, useState } from "react";
import GraphComponent from "../../Component/GraphComponent/GraphComponent";
import MiniDrawer from "../../Component/newNavBarCM/newNavBar";
import { getExpertAnalyticsDataInOverview, getRatingGroupsByGeo, getExpertQCountsInOverview, getCurationDataForGraph, getAuditLogs } from "../../API/api";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../Action";
import { bindActionCreators } from "redux";
import { Box, Paper, Typography } from "@mui/material";
import { Grid } from "@mui/material";
import SelectComponentForOverview from "../../Component/SelectComponentForOverview/SelectComponentForOverview";
import SelectComponentMonthsDuration from "../../Component/SelectMonthsDurationCMGraphs/SelectComponentMonthsDuration";
import SelectSourceComponentOverview from "../../Component/SelectSourceComponentOverview/SelectSourceComponentOverview";
import VizHeader from "../../Component/VizHeader/VizHeader";
import Layout from '../../NewComponent/LayoutCM/Layout';

export default function CMExpertOverviewPage() {
	const state = useSelector(state => state.cmRoot);
	const expertOverview = useSelector((state) => state.expertOverviewCmReducer)
	const dispatch = useDispatch();
	const { getExpertAnalyticsDataInCmOverview, getRatingsInExpertOverviewForCM, getRatingStarsInExpertOverviewCM, getExpertsQCountsDataInOverview, getCurationCountCMExpert, getAuditLogsDataInCMOverviewSeeker } = bindActionCreators(Actions, dispatch);
	const [RatedData, setRatedData] = useState([])
	const [nonRatedData, setNonRated] = useState([])

	useEffect(() => {
		{/* REMOVE STATIC DATA */ }
		getExpertAnalyticsDataInOverview(3,
			"", 0).then((res) => {
				if (res===undefined) return;
				if (res.data.data !== undefined || res.data.success) {
					getExpertAnalyticsDataInCmOverview(res.data.data);
				}
			})
		getRatingGroupsByGeo(3, "", false, 0).then((res) => {
			if (res===undefined) return;
			if (res.data.data !== undefined || res.data.success) {
				getRatingsInExpertOverviewForCM(res.data.data);
				getRatingStarsInExpertOverviewCM(res.data.data);
			}
		})
		getExpertQCountsInOverview("0,1,2,3,4,5,6,7,8,9,10,11,21,22,23,24,25").then((res) => {
			if (res===undefined) return;
			if (res.data.data !== undefined || res.data.success) {
				getExpertsQCountsDataInOverview(res.data.data)
			}
		})
		getCurationDataForGraph(3, "", "0,1,2,3,4,5,6,7,8,9,10,11,21,22,23,24,25", "High", "desc").then((res) => {
			if (res===undefined) return;
			if (res.data.data !== undefined || res.data.success) {
				getCurationCountCMExpert(res.data.data);

			}
		},
			/* Overview for Seeker graphs API start */
			/* Overview for Seeker graphs API end */
		)
	}, [])
	return (
		<>
			<Box pt={7}>
				<Layout>
					<Grid container spacing={2} xs={12}>
						<Grid item lg={6} xl={6}>
							<Paper>
								<Box>
									<Typography sx={{ textAlign: 'center' }}>Questions Answered - Top 15</Typography>
									<GraphComponent type="Bar" name="Questions Answered" />
								</Box>
							</Paper>
						</Grid>
						<Grid item lg={6} xl={6}>
							<Paper>
								{/* <text>Answers Viewed - Top 15</text> */}
								<Typography sx={{ textAlign: 'center' }}>Answers Viewed - Top 15</Typography>
								<GraphComponent type="Bar" name="Answers Viewed" />
							</Paper>
						</Grid>
					</Grid>
					<Grid container pt={1} spacing={2} xs={12}>
						<Grid item lg={6} xl={6}>
							<Paper>
								<Grid container>
									<Grid item pt={2}>
										{expertOverview.ratings !== null
											&&
											<GraphComponent type="Bar" name="Ratings" data={expertOverview.ratings} />
										}
									</Grid>
									<Grid item>
										<div style={{textAlign:'center'}}>
											<VizHeader type={4}>Ratings of Expert Answers</VizHeader></div>
										<GraphComponent type="Pie" name="Ratings of Expert Answers" />
									</Grid>
								</Grid>
							</Paper>
						</Grid>
						<Grid item lg={6} xl={6}>
							<Paper>
							</Paper>
						</Grid>
					</Grid>
					<Grid container paddingTop={1} xs={12} xl={12} md={12} sm={12}>
						<Grid item xs={12}>
							<Paper>
								<Box sx={{ width: '100%' }}>
									<Typography sx={{ textAlign: 'center' }}>Ratings Received by Experts</Typography>
									<GraphComponent type="Bar" name="Ratings Received" />
								</Box>
							</Paper>
						</Grid>
					</Grid>
					<Grid container paddingTop={1}>
						<Grid item xs={6}>

						</Grid>
						<Grid item xs={12} sm={12} lg={6} xl={6} md={12}>
							<Paper>
								<Typography sx={{ textAlign: 'center' }}>Curation Status Breakdown - Top 15</Typography>
								<GraphComponent type="Bar" name="Curation Status Breakdown" />
							</Paper>
						</Grid>
					</Grid>
					{/* Overview Seeker graphs start */}
					<Grid container paddingTop={1} xs={12} md={12}>
						<Grid item xs={12}>
							<Paper>
								<Grid container>
									<Grid item xs={8}>
										<Typography textAlign={"center"}>
											Questions Searched/Submitted/Answered
										</Typography>
									</Grid>
									<Grid item xs={4}>
										<Box display="flex" justifyContent="flex-end">
											<div style={{ width: '50%' }}>
												<SelectComponentMonthsDuration />
											</div>
										</Box>
									</Grid>
								</Grid>
								<GraphComponent type="Multiple" name="Questions Searched/Submitted/Answered" />
							</Paper>
						</Grid>
					</Grid>
					<Grid container paddingTop={1} xs={12} md={12}>
						<Grid item xs={12}>
							<Paper>
								<Grid container>
									<Grid item xs={8}>
										<Typography textAlign={"center"}>
											Questions Submitted to Experts
										</Typography>
									</Grid>
									<Grid item xs={4}>
										<Box display="flex" justifyContent="flex-end">
											<div style={{ width: '50%' }}>
												<SelectComponentMonthsDuration />
											</div>
										</Box>
									</Grid>
								</Grid>
								<GraphComponent type="Line" name="Questions Submitted to Experts" />
							</Paper>
						</Grid>
					</Grid>
					<Grid container paddingTop={1} xs={12} md={12}>
						<Grid item xs={12}>
							<Paper>
								<Grid container>
									<Grid item xs={8}>
										<Typography style={{ textAlign: 'center' }}>Answered By Vizerto</Typography>
									</Grid>
									<Grid item xs={4}>
										<Grid container>
											<div style={{ width: '48%' }}>
												<SelectSourceComponentOverview />
											</div>
											<div style={{ width: '50%' }}>
												<SelectComponentMonthsDuration />
											</div>
										</Grid>
									</Grid>
								</Grid>
								<GraphComponent type="Composed" name="Answered By Vizerto" />
							</Paper>
						</Grid>
					</Grid>
					<Grid container paddingTop={1} xs={12} md={12}>
						<Grid item xs={12}>
							<Paper>
								<Grid container>
									<Grid item xs={8}>
										<Typography style={{ textAlign: 'center' }}>
											{expertOverview.actionValue.label}
										</Typography>
									</Grid>
									<Grid item xs={4}>
										<Grid container>
											<div style={{ marginRight: '5px', width: '48%' }}>
												<SelectComponentForOverview />
											</div>
											<div style={{ width: '50%' }}>
												<SelectComponentMonthsDuration />
											</div>
										</Grid>
									</Grid>
								</Grid>
								<GraphComponent type="Area" name="Trending Search" />
							</Paper>
						</Grid>
					</Grid>
					{/* Overview Seeekr graphs end */}
				</Layout>
			</Box>
		</>
	)
}